import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pagePreviews } from '../../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PagesCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const total = pagePreviews.length;
  const current = pagePreviews[index];
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  return <div role="group" aria-roledescription="carrusel" aria-label="Páginas de ejemplo del método" className="mx-auto w-full max-w-[430px]" onKeyDown={event => {
    if (event.key === 'ArrowRight') go(index + 1);
    if (event.key === 'ArrowLeft') go(index - 1);
  }} tabIndex={0} data-id="element-227" data-mp="f36axsztq0x2">
      <div className="relative overflow-hidden rounded-2xl border border-ink-border bg-white shadow-panel" data-id="element-228" data-mp="20idfwv9fgbna">
        <div className="relative aspect-[1/1.414] w-full" data-id="element-229" data-mp="39oxw964yjdwj">
          <AnimatePresence initial={false} custom={direction} data-id="element-230" data-mp="39nd2hiqgvyzq">
            <motion.img key={current.src} src={current.src} alt={current.alt} loading="lazy" decoding="async" draggable={false} custom={direction} initial={{
            opacity: 0,
            x: direction * 48
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -48
          }} transition={{
            duration: 0.25,
            ease: EASE
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.12} onDragEnd={(_, info) => {
            if (info.offset.x < -60) go(index + 1);
            if (info.offset.x > 60) go(index - 1);
          }} className="absolute inset-0 h-full w-full cursor-grab object-contain active:cursor-grabbing" data-id="element-231" data-mp="34plc4t5h0kxn" />
          </AnimatePresence>
        </div>
      </div>

      <div className="mt-5 flex items-center justify-center gap-4" data-id="element-232" data-mp="33tftspw3lwae">
        <button type="button" onClick={() => go(index - 1)} aria-label="Página anterior" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-ink-border bg-ink-card text-white transition-colors duration-150 ease-out hover:border-brand-green hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green" data-id="element-233" data-mp="38s98umr19vco">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-234" data-mp="2p2p71w9d5ne5" />
        </button>
        <p aria-live="polite" className="min-w-[86px] text-center text-sm font-semibold text-body" data-id="element-235" data-mp="2u21qs84xueci">
          {index + 1} / {total}
        </p>
        <button type="button" onClick={() => go(index + 1)} aria-label="Página siguiente" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-ink-border bg-ink-card text-white transition-colors duration-150 ease-out hover:border-brand-green hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green" data-id="element-236" data-mp="21g0f0hqn4ejt">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-237" data-mp="1oyprmhzkf6q5" />
        </button>
      </div>

      <p className="mt-4 text-center text-sm leading-relaxed text-subtle" data-id="element-238" data-mp="1kxm91nq4uwl8">{current.alt}</p>

      <ul className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-239" data-mp="1fy9pbbuk65mv">
        {pagePreviews.map((page, i) => <li key={page.src} data-id="element-240" data-mp="166dgb5qxov3v" data-mpi={i}>
            <button type="button" onClick={() => go(i)} aria-label={`Ver página ${i + 1}`} aria-current={i === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-7 bg-brand-green' : 'w-2.5 bg-ink-border hover:bg-subtle'}`} data-id="element-241" data-mp="167f1i31nyxzb" />
          </li>)}
      </ul>
    </div>;
}